'use client';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { ImageProps } from '@repo/ui/src/types/image';
import { classNames } from '@repo/ui/src/utils/classNames';
import Button from '@repo/ui/src/components/Button';
import { Anchor } from '@repo/ui/src/components/Anchor';
import { AmplienceButtonProps } from '@repo/ui/src/types/button';
import { getButtonVariant } from '@repo/ui/src/components/Button/utils';
import Image from '@repo/ui/src/components/Image/New';

export interface QuoteProps {
  text: string;
  quoteAuthor?: string;
  profileStyle: boolean;
  image: ImageProps;
  button: AmplienceButtonProps;
}

const Quote = ({ text, quoteAuthor, profileStyle, image, button }: QuoteProps) => {
  const imgUrl = buildImageSrc(image, 300, 0, 0);

  return (
    <div className="w-full grid gap-8 my-8 px-4 sm:px-12 flex-col sm:grid-flow-col content-center place-items-center">
      <div
        className={classNames(
          'hidden md:flex items-center relative aspect-square w-full min-w-40',
          profileStyle ? 'rounded-full' : '',
        )}
      >
        <Image
          src={imgUrl}
          alt={`${quoteAuthor} Logo`}
          fill
          className={classNames(
            'mb-10 object-contain',
            profileStyle ? 'rounded-full w-40' : 'w-24',
          )}
        />
      </div>
      <div className="flex flex-col">
        {text && (
          <h3
            className={classNames(
              'tra-text-web-heading-3 text-center md:text-left',
              !!(quoteAuthor || button?.link?.displayName) && 'mb-6',
            )}
          >
            {`"${text}"`}
          </h3>
        )}
        {quoteAuthor && (
          <h6
            className={classNames(
              'text-center md:text-left',
              !!button?.link?.displayName && 'mb-6',
            )}
          >
            &mdash; {quoteAuthor}
          </h6>
        )}
        {button?.link?.displayName && (
          <div className="flex content-center sm:content-start">
            <Button
              {...button.link}
              variant={getButtonVariant(button.style, button.icon)}
              as={Anchor}
              dark
            >
              {button.link.displayName}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Quote;
